import { useReq } from '@/utils/request/useReq'

const coinInfoUrl = '/account/get/trade/coinId/info'
const coinInfo = (params = {}, options = {}) =>
  useReq(coinInfoUrl, { method: 'POST', data: params, auth: false }, { immediate: false, ...options })

const needLoginUrl = []

export default {
  needLoginUrl,
  coinInfo,
}
